import React from "react";
import { Box } from "../Box";
import { Title } from "../Title";
import { FaqAccordion, FaqAccordionProps } from "../FaqAccordion";

export interface FaqAccordionGroupProps {
  title?: string;
  faqs: FaqAccordionProps[];
}

export const FaqAccordionGroup: React.FC<FaqAccordionGroupProps> = ({ title, faqs }) => {
  if (!faqs || !faqs.length) {
    return null;
  }
  return (
    <Box data-testid="FaqAccordionGroup">
      <Title as="h2" pb={2}>
        {title}
      </Title>
      {faqs.map(faq => (
        <Box key={`${faq.question}`} mt={3}>
          <FaqAccordion {...faq} />
        </Box>
      ))}
    </Box>
  );
};

FaqAccordionGroup.defaultProps = {
  title: "Frequently Asked Questions",
};
